import React, { Dispatch, SetStateAction } from 'react';
import {
  View, StyleSheet, Text, Platform, ScrollView,
} from 'react-native';
import { TicketPriority, UserGroup } from '../../../../../../../../constants/Types';
import Colors from '../../../../../../../../constants/Colors';
import isMobile from '../../../../../../../IsMobile';
import Style from '../../../../../../../../constants/Style';
import UserIcon24 from '../../../../../../../24pxIcons/UserIcon24';
import SelectionModal from '../../../../../../../SelectionModal';
import ChangeGroupList from './ChangeGroupList';
import DropdownIcon12 from '../../../../../../../12pxIcons/DropdownIcon12';
import PressableStyled from '../../../../../../../PressableStyled';
import CloseIconSmall from '../../../../../../../12pxIcons/CloseIconSmall';

interface UserGroupTagProps {
  groups: UserGroup[],
  itemIndex: number,
  tags: string[],
  tag: string,
  addTagIconDisabled: boolean,
  tagDropdownShownIndex: number,
  issueTagDropdownShownIndex: number,
  setTagDropdownShownIndex: Dispatch<SetStateAction<number>>,
  index: number,
  priority: TicketPriority,
  enabled: boolean,
  title: string,
  updateIssue,
  hideDropdowns: () => void,
  toggleChangeGroupMenu,
}

const UserGroupTag = ({
  groups, itemIndex, tags, tag, addTagIconDisabled, tagDropdownShownIndex, index, priority, enabled,
  issueTagDropdownShownIndex, setTagDropdownShownIndex, updateIssue, title, hideDropdowns,
  toggleChangeGroupMenu,
}: UserGroupTagProps) => {
  const name: string = groups?.filter((group: UserGroup) => group.UserGroupId
    === tag)[0]?.Name;
  const tagSelected: boolean = tagDropdownShownIndex === itemIndex
    && issueTagDropdownShownIndex === index;

  return name && <View
    key={`tag_indicator_${index}_${itemIndex}`}
    style={[styles.tagContainer, { zIndex: (tags?.length ?? 0) - itemIndex }]}
  >
    <PressableStyled
      onPress={() => toggleChangeGroupMenu(itemIndex)}
      style={styles.tag}
      disabled={addTagIconDisabled}
    >
      <UserIcon24 />
      <Text style={styles.tagText}>{name}</Text>
      {!addTagIconDisabled && <DropdownIcon12
        style={tagSelected ? Style.inverted : Style.upright}
      />}
      <PressableStyled
        onPress={() => {
          setTagDropdownShownIndex(-1);
          const updatedTags = [...tags];
          updatedTags.splice(itemIndex, 1);
          updateIssue(title, updatedTags, priority, enabled);
          hideDropdowns();
        }}
        hitSlop={{
          top: 2, bottom: 2, left: 3, right: 3,
        }}
      >
        <CloseIconSmall />
      </PressableStyled>
    </PressableStyled>
    {isMobile ? <SelectionModal
      listContent={<ChangeGroupList
        {...{ groups, tags, itemIndex }}
        update={(userGroupId: string) => {
          const updatedTags: string[] = tags ?? [];
          updatedTags[itemIndex] = userGroupId;
          updateIssue(title, updatedTags, priority, enabled);
          hideDropdowns();
        }}
      />}
      title='Select user group'
      isVisible={tagSelected}
      hide={() => setTagDropdownShownIndex(-1)}
    /> : (tagSelected && <ScrollView
      style={[styles.dropdown, styles.tagDropdown]}
      nestedScrollEnabled
    >
      <ChangeGroupList
        {...{ groups, tags, itemIndex }}
        update={(userGroupId: string) => {
          const updatedTags: string[] = tags ?? [];
          updatedTags[itemIndex] = userGroupId;
          updateIssue(title, updatedTags, priority, enabled);
          hideDropdowns();
        }}
      />
    </ScrollView>)}
  </View>;
};

const styles = StyleSheet.create({
  dropdown: {
    position: 'absolute',
    width: 170,
    borderWidth: 1,
    borderRadius: 10,
    borderColor: Colors.light.hereworksBlue100,
    backgroundColor: '#FFF',
    alignSelf: 'center',
    overflow: 'hidden',
    zIndex: 20,
  },
  tag: {
    backgroundColor: Colors.light.hereworksDarkBlue,
    borderRadius: 8,
    paddingVertical: 4,
    paddingHorizontal: 8,
    marginVertical: 2,
    alignSelf: 'flex-start',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginEnd: 8,
  },
  tagText: {
    color: '#FFF',
    fontFamily: 'Roboto_400Regular',
    fontSize: 16,
    lineHeight: 24,
    marginHorizontal: 4,
    flex: isMobile ? undefined : 1,
  },
  tagDropdown: {
    position: Platform.OS === 'android' ? 'relative' : 'absolute',
    start: 0,
    top: Platform.OS === 'android' ? undefined : 38,
    marginVertical: Platform.OS === 'android' ? 4 : undefined,
    maxHeight: 180,
    alignSelf: 'flex-start',
  },
  tagContainer: {
    alignSelf: 'flex-start',
  },
});

export default UserGroupTag;
